export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

export const SUBSCRIPTION_ERROR_MESSAGE = 'An active subscription is required.';

export const FILE_UPLOAD_ERROR_MESSAGE = 'File upload failed, please try again.';
